import { ColorPicker, useColor } from 'react-color-palette'
import 'react-color-palette/lib/css/styles.css'

const KTColorPicker = () => {
  const [color, setColor] = useColor('hex', '#121212')

  return <ColorPicker width={500} height={250} color={color} onChange={setColor} hideHSV dark />
}

export default KTColorPicker
